import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "teres" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_message = _resolveComponent("error-message")!
  const _component_privacy_overlay = _resolveComponent("privacy-overlay")!
  const _component_info_popup = _resolveComponent("info-popup")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.permissionerror)
        ? (_openBlock(), _createBlock(_component_error_message, {
            key: 0,
            i18nMessage: "common.permissionerror"
          }))
        : _createCommentVNode("", true),
      (!_ctx.permissionerror && _ctx.privacyNotice === false)
        ? (_openBlock(), _createBlock(_component_privacy_overlay, { key: 1 }))
        : _createCommentVNode("", true),
      (!_ctx.permissionerror && _ctx.privacyNotice === true)
        ? (_openBlock(), _createBlock(_component_info_popup, { key: 2 }))
        : _createCommentVNode("", true),
      (!_ctx.permissionerror && _ctx.privacyNotice === true)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 3 }))
        : _createCommentVNode("", true)
    ])
  ]))
}